module.exports = __webpack_public_path__ + "img/icon-thank-you.eebfa570.svg";